import { useState, useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Avatar, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from 'react-router-dom';
import imagem from '../../assets/jap.png';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';

function Header({ onToggleSidebar, onCloseSidebar }) {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('token');

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userPhoto, setUserPhoto] = useState(null);

  useEffect(() => {
    const foto = localStorage.getItem('foto');
    if (foto) {
      setUserPhoto(`data:image/jpeg;base64,${foto}`);
    }
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    if (typeof onCloseSidebar === "function") {
      onCloseSidebar();
    }
    localStorage.removeItem('token');
    localStorage.removeItem('funcionario');
    localStorage.removeItem('foto');
    localStorage.removeItem('permissoes');
    navigate('/login');
  };

  return (
    <AppBar position="static" color="primary" elevation={0}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: 64,
          px: { xs: 1.5, sm: 2 },
        }}
      >

        {/* Botão do Menu */}
        {isLoggedIn && (
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={onToggleSidebar}>
            <MenuIcon />
          </IconButton>
        )}

        {/* Logo */}
        <Link to="/feed" style={{ display: 'flex', alignItems: 'center' }}>
          <Box component="img" src={imagem} alt="Logo Jap" sx={{ maxHeight: { xs: 30, sm: 38 } }} />
        </Link>

        {/* Avatar + Menu de Opções */}
        {isLoggedIn && (
          <>
            <IconButton onClick={handleMenuOpen}>
              <Avatar
                src={userPhoto || ""}
                sx={{
                  bgcolor: userPhoto ? 'transparent' : 'secondary.main',
                  width: 36,
                  height: 36,
                  border: '2px solid rgba(255,255,255,0.4)',
                }}
              >
                {!userPhoto && "U"} {/* Se não tiver foto, exibe a inicial "U" */}
              </Avatar>
            </IconButton>

            <Menu 
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
              <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Sair
              </MenuItem>
            </Menu>
          </>
        )}

      </Toolbar>
    </AppBar>
  );
}

export default Header;
